import { PDF } from "./actionTypes";

export const setHasChanges = (payload) => ({ type: PDF.SETHASCHANGES, payload });

export const setPdfViewer = (payload) => ({ type: PDF.SETPDFVIEWER, payload });

export const setReadOnly = (payload) => ({ type: PDF.SETREADONLY, payload });
